import React from 'react';

export default function ValueManager({children, value, onChange, valueField = 'value'}) {
	const [incomingValue, setIncomingValue] = React.useState(value);
	const [currentValue, setCurrentValue] = React.useState(value);
	
	const handleChange = (e) => {
		setCurrentValue(e.target[valueField]);
		if(onChange)onChange(e);
	}

	React.useEffect(() => {
		if(incomingValue !== value) {
			setIncomingValue(value);
			setCurrentValue(value);
		}
	},[incomingValue, value]);

	return React.cloneElement(React.Children.only(children), {[valueField]: currentValue, onChange:handleChange});
}